/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';

import { removeFromLocalStorage } from '../utils/storage';

import GenericButton from '../components/button/GenericButton';
import { Terms } from '../components/footer-terms/Terms';
import AnimatedSnowImage from '../components/AnimatedSnowImage';

import '../index.css';
import './LandingScreen.css';

const LandingScreen = () => {
  useEffect(() => {
    removeFromLocalStorage('gameSessionStarted');
  }, []);

  return (
    <div className='landing-screen blue-bg'>
      <div className='landing-container'>
        <AnimatedSnowImage />
        <div
          className='landing-header'
          style={{
            height: '200px',
            width: '100%'
          }}
        >
          <img
            src='/assets/landing-background-home_v2.webp'
            alt='Snowman'
            width='90%'
            className='landing-image'
          />
          <img
            src='/assets/SkysTheLimit2_Logo.webp'
            alt='Sky Logo'
            width='300px'
            className='landing-logo'
          />
        </div>
        <div className='button-container'>
          <GenericButton page='/how-to-play' text='PLAY NOW' />
          <span className='subtitle'>Must be 18 to play</span>
        </div>
        <div className='landing-footer'>
          <div className='landing-footer-content'>
            <img
              className='snow-image-2'
              src='/assets/snowman-snow-2.png'
              alt='Snowman'
              width='100%'
            />
            <img
              className='tickets-image'
              src='/assets/home-tikets-01.png'
              alt='Snowman'
              width='100%'
            />
            <img
              className='snow-image-1'
              src='/assets/snowman-snow-1.png'
              alt='Snowman'
              width='100%'
            />
            <div className='landing-footer-buttons'>
              <Terms color='#0a1f55' showShareButtons shareButtonsRedirect />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingScreen;
